import React from "react";
import { useTranslation } from "react-i18next";

export default function Policies() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.6" }}>
      
      <h1>{t("policies.title")}</h1>
      <p>{t("policies.last_updated")}</p>

      {/* 1. Introduction */}
      <h2>{t("policies.sections.introduction.title")}</h2>
      <p>{t("policies.sections.introduction.text")}</p>

      {/* 2. Information We Collect */}
      <h2>{t("policies.sections.collection.title")}</h2>
      <p>{t("policies.sections.collection.text")}</p>
      <ul>
        {t("policies.sections.collection.list", { returnObjects: true }).map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      {/* 3. How We Use Your Information */}
      <h2>{t("policies.sections.usage.title")}</h2>
      <p>{t("policies.sections.usage.text")}</p>
      <ul>
        {t("policies.sections.usage.list", { returnObjects: true }).map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      {/* 4. No Cookies Policy */}
      <h2>{t("policies.sections.no_cookies.title")}</h2>
      <p>{t("policies.sections.no_cookies.text")}</p>

      {/* 5. Data Sharing */}
      <h2>{t("policies.sections.data_sharing.title")}</h2>
      <p>{t("policies.sections.data_sharing.text")}</p>

      {/* 6. Data Security */}
      <h2>{t("policies.sections.data_security.title")}</h2>
      <p>{t("policies.sections.data_security.text")}</p>

      {/* 7. User Rights */}
      <h2>{t("policies.sections.user_rights.title")}</h2>
      <p>{t("policies.sections.user_rights.text")}</p>
      <ul>
        {t("policies.sections.user_rights.list", { returnObjects: true }).map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      {/* 8. Booking Terms */}
      <h2>{t("policies.sections.booking_terms.title")}</h2>
      <p>{t("policies.sections.booking_terms.text")}</p>

      {/* 9. Liability */}
      <h2>{t("policies.sections.liability.title")}</h2>
      <p>{t("policies.sections.liability.text")}</p>

      {/* 10. Contact */}
      <h2>{t("policies.sections.contact.title")}</h2>
      <p>{t("policies.sections.contact.text")}</p>

    </div>
  );
}